import React from 'react';
import { SalesBookingsChart } from './charts/SalesBookingsChart';
import { ErrorBar, LoadingBar } from 'ui/NetworkStatusBar';
import { ISalesMetricsResponse } from 'services/DashboardApi/types';
import { KpiCards } from './KpiCards';

interface IKpiCardsDataProps {
  salesMetricsData: ISalesMetricsResponse;
}

export const KpiCardsData: React.FC<IKpiCardsDataProps> = ({ salesMetricsData }) => {
  if (!salesMetricsData?.summary) {
    return null;
  }

  return (
    <KpiCards
      totalBookings={salesMetricsData.summary.totalBookings}
      totalValueCents={salesMetricsData.summary.totalValueCents}
      bookingsChangePercent={salesMetricsData.summary.bookingsChangePercent}
      valueChangePercent={salesMetricsData.summary.valueChangePercent}
    />
  );
};

interface ISalesMetricsDataProps {
  salesMetricsData?: ISalesMetricsResponse;
  isLoadingSalesMetricsData: boolean;
  isErrorSalesMetricsData: boolean;
}

export const SalesMetricsData: React.FC<ISalesMetricsDataProps> = ({
  salesMetricsData,
  isLoadingSalesMetricsData,
  isErrorSalesMetricsData,
}) => {
  if (isErrorSalesMetricsData) {
    return (
      <div className="w-full flex justify-center items-center mt-5 mb-5">
        <ErrorBar />
      </div>
    );
  }

  if (isLoadingSalesMetricsData || !salesMetricsData) {
    return (
      <div className="w-full flex justify-center items-center mt-5 mb-5">
        <LoadingBar label="Loading" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-[20px]">
      <KpiCardsData salesMetricsData={salesMetricsData} />

      <div className="border border-solid border-gray-20">
        <SalesBookingsChart salesMetricsByMonth={salesMetricsData.byMonth} />
      </div>
    </div>
  );
};
